import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import styled, { css } from 'styled-components'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { MarkerCapShortFormatted } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'

import { TradingPairExploreItemMetricsItem } from './pair-explore-item-metrics-item'

import type { Intent as BaseIntent } from '@blade/ui-kit'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Intent = Exclude<BaseIntent, 'accent'> | undefined

type Props = {
  pair: PairModel
} & ClassNameProps

export const TradingPairExploreItemMetricsMcap = memo(
  ({ pair, className }: Props) => {
    const { t } = useTranslation()

    const [marketCapUsd] = useAtom(pair.marketCapUsd)

    return (
      <TradingPairExploreItemMetricsItem className={className}>
        <TradingPairExploreItemMetricsItem.Label>
          {t('pool.mcap_char')}
        </TradingPairExploreItemMetricsItem.Label>
        <FlashTextContentDistinct>
          <ItemMarketCap>
            <MarkerCapShortFormatted mcap={marketCapUsd} />
          </ItemMarketCap>
        </FlashTextContentDistinct>
      </TradingPairExploreItemMetricsItem>
    )
  },
)

const ItemMarketCap = styled.div<{ $intent?: Intent }>`
  color: var(--amber-10);

  ${({ $intent }) => {
    switch ($intent) {
      case 'error': {
        return css`
          color: var(--down-9);
        `
      }
      case 'warning': {
        return css`
          color: var(--amber-10);
        `
      }
      case 'success': {
        return css`
          color: var(--up-9);
        `
      }
    }
  }}
`
